import { CellProps } from 'react-table'
import { FormularioAtendimentoList } from '../../core/_models'
import { AvaliacoesPendentesSelectionHeader } from './AvaliacoesPendentesSelectionHeader'
import { AvaliacoesPendentesSelectionCell } from './AvaliacoesPendentesSelectionCell'
import { AvaliacoesPendentesActionsCell } from './AvaliacoesPendentesActionsCell'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { PlainHeader, sortableColumn, StackedCell, TableColumn } from '../../../../../../components'
import { TFunction } from '_metronic/i18n/Metronici18n'

/**
 * @param isMedico só médico assina e visualiza: para os demais as colunas de seleção e de ações
 * não aparecem (não há nada que possam fazer nelas).
 */
export const avaliacoesPendentesColumns = (
  t: TFunction,
  isMedico: boolean
): ReadonlyArray<TableColumn<FormularioAtendimentoList>> => [
  ...(isMedico
    ? [
        {
          Header: () => <AvaliacoesPendentesSelectionHeader />,
          id: 'selection',
          cellWidth: '48px',
          Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
            <AvaliacoesPendentesSelectionCell
              atendimentoId={row.original.atendimento?.id}
              formularioAtendimentoId={row.original.id}
              ariaLabel={`Selecionar avaliação de ${row.original.paciente?.nome ?? ''}`}
            />
          ),
        } as TableColumn<FormularioAtendimentoList>,
      ]
    : []),
  // Protocolo do atendimento como linha de apoio do paciente; os dois seguem ordenáveis.
  sortableColumn<FormularioAtendimentoList>({
    id: 'atendimento.paciente.pessoa.nome',
    useQueryRequest,
    fields: [{ field: 'atendimento.paciente.pessoa.nome', label: t('cols.paciente') }],
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <StackedCell primary={row.original.paciente?.nome} />
    ),
  }),
  sortableColumn<FormularioAtendimentoList>({
    id: 'atendimento.protocolo',
    useQueryRequest,
    fields: [{ field: 'atendimento.protocolo', label: t('cols.protocolo') }],
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <StackedCell primary={row.original.atendimento?.protocolo} />
    ),
  }),
  // Avaliação (formulário) com a especialidade do atendimento como apoio.
  sortableColumn<FormularioAtendimentoList>({
    id: 'formulario.nome',
    useQueryRequest,
    fields: [
      { field: 'formulario.nome', label: 'Avaliação' },
      { field: 'atendimento.especialidade.nome', label: t('cols.especialidade') },
    ],
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <StackedCell
        primary={row.original.formulario?.nome}
        secondary={row.original.atendimento?.especialidade?.nome}
      />
    ),
  }),
  // Finalização (ordem padrão: mais recente primeiro); o backend já manda formatada.
  sortableColumn<FormularioAtendimentoList>({
    id: 'data',
    cellWidth: '168px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'data', label: 'Finalização' }],
    Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
      <StackedCell tabular primary={row.original.dataFormatada} />
    ),
  }),
  ...(isMedico
    ? [
        {
          Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
          id: 'actions',
          cellWidth: '132px',
          align: 'end',
          Cell: ({ row }: CellProps<FormularioAtendimentoList>) => (
            <AvaliacoesPendentesActionsCell formularioAtendimento={row.original} />
          ),
        } as TableColumn<FormularioAtendimentoList>,
      ]
    : []),
]
